<template>
  <!-- <div class="header" :class="{[`bg-${type}`]: type}"> -->
    <div class="header">
    <div class="header-body-wrap">
      <div class="header-body">
        <slot></slot>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'base-header',
    props: {
      type: {
        type: String,
        default: 'success',
        description: 'Header background type'
      }
    }
  }
</script>
<style>
</style>
